var map = {
	"./icons/arrow.svg": [
		"IeLI",
		37
	],
	"./icons/arrow_down.svg": [
		"SxpZ",
		38
	],
	"./icons/arrow_left.svg": [
		"k664",
		39
	],
	"./icons/arrow_right.svg": [
		"5F/A",
		40
	],
	"./icons/as_seen_in_desktop.svg": [
		"DCXk",
		41
	],
	"./icons/background_line_1.svg": [
		"S1Yf",
		42
	],
	"./icons/background_line_2.svg": [
		"De2H",
		43
	],
	"./icons/blood_sugar_changes_chart.svg": [
		"jxYu",
		0
	],
	"./icons/checkmark.svg": [
		"HsMd",
		44
	],
	"./icons/checkmark_blue.svg": [
		"p+aW",
		45
	],
	"./icons/checkmark_outlined.svg": [
		"DWRY",
		46
	],
	"./icons/checkmark_table.svg": [
		"7aeY",
		47
	],
	"./icons/cholesterol_levels.svg": [
		"sN8z",
		4
	],
	"./icons/close_popup.svg": [
		"elcT",
		48
	],
	"./icons/cross.svg": [
		"KtfD",
		49
	],
	"./icons/cross_table.svg": [
		"g/Qz",
		50
	],
	"./icons/curve.svg": [
		"uQIe",
		51
	],
	"./icons/cycle.svg": [
		"JQ+w",
		52
	],
	"./icons/expert_approved.svg": [
		"CQSV",
		53
	],
	"./icons/gender_female.svg": [
		"Sgyv",
		54
	],
	"./icons/gender_male.svg": [
		"x3MF",
		55
	],
	"./icons/gender_non_binary.svg": [
		"+zxT",
		56
	],
	"./icons/green_heart.svg": [
		"X0H8",
		0
	],
	"./icons/group_of_humans.svg": [
		"qNys",
		0
	],
	"./icons/leaves_1.svg": [
		"xCWq",
		57
	],
	"./icons/leaves_2.svg": [
		"71h2",
		58
	],
	"./icons/libra_sign.svg": [
		"b1X8",
		59
	],
	"./icons/logo.svg": [
		"WxzP",
		60
	],
	"./icons/logo_mobile.svg": [
		"Tmah",
		61
	],
	"./icons/man_emoji.svg": [
		"1mGk",
		62
	],
	"./icons/minus.svg": [
		"PiRy",
		63
	],
	"./icons/money_back_guarantee.svg": [
		"Xohi",
		64
	],
	"./icons/personalized.svg": [
		"28LY",
		65
	],
	"./icons/plus.svg": [
		"6zi+",
		66
	],
	"./icons/promise.svg": [
		"CUJ3",
		67
	],
	"./icons/red_heart.svg": [
		"x6n7",
		0
	],
	"./icons/risk_icon.svg": [
		"RaFC",
		0
	],
	"./icons/stars_4.svg": [
		"aC2w",
		68
	],
	"./icons/stars_5.svg": [
		"V99O",
		69
	],
	"./icons/status_arrow_left.svg": [
		"HIPv",
		70
	],
	"./icons/status_arrow_right.svg": [
		"0Js9",
		71
	],
	"./icons/stockup_emoji.svg": [
		"LPLf",
		72
	],
	"./icons/table_info.svg": [
		"yxVJ",
		73
	],
	"./icons/woman_emoji.svg": [
		"5aAg",
		74
	],
	"./images/checkout/reflux_wedge_pillow_lines.svg": [
		"acMI",
		75
	],
	"./images/footer/facebook.svg": [
		"bGFn",
		76
	],
	"./images/footer/instagram.svg": [
		"+huU",
		77
	],
	"./images/footer/linkedin.svg": [
		"wRWr",
		78
	],
	"./images/footer/twitter.svg": [
		"O5ej",
		79
	],
	"./images/home/lines.svg": [
		"tz1S",
		80
	],
	"./images/quiz/alcohol_glass.svg": [
		"UF7x"
	],
	"./images/quiz/cigarette.svg": [
		"6JQM"
	],
	"./images/quiz/none.svg": [
		"pv5T"
	],
	"./images/quiz/stress.svg": [
		"0S3p"
	],
	"./images/summary-3/blood_sugar_graph.svg": [
		"cbk+",
		1
	],
	"./images/summary-3/cholesterol_with.svg": [
		"M+HO",
		1
	],
	"./images/summary-3/cholesterol_without.svg": [
		"uk2m",
		10
	],
	"./images/summary-3/with_pulsio_graph.svg": [
		"xPRm",
		1
	],
	"./images/summary-3/without_pulsio_graph.svg": [
		"a7oz",
		1
	],
	"./images/summary/risk_factor_graph_high.svg": [
		"MAgS",
		81
	],
	"./images/summary/risk_factor_graph_low.svg": [
		"VTvn",
		82
	],
	"./images/summary/risk_factor_graph_mid_high.svg": [
		"2/DN",
		83
	],
	"./images/summary/risk_factor_graph_mid_lower.svg": [
		"dRII",
		84
	],
	"./images/summary/your_sugar_changes.svg": [
		"9lfh",
		85
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(function() {
		return __webpack_require__.t(id, 7);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "fnv4";
module.exports = webpackAsyncContext;